import React, { Component } from 'react'
import SVGInline from 'react-svg-inline'
import { Trans } from '@lingui/react'

import './discount-badge.styl'

import DiscountBackground from './discount_bg.svg'

type Props = {
  type: 'plan-option' | 'three_months'
  discountPercent: number
}

export default class DiscountBadge extends Component<Props> {
  static defaultProps = {
    type: 'plan-option',
    kind: 'premium',
  }

  render(): JSX.Element {
    const { type, discountPercent } = this.props

    return (
      <div className={`discount-badge discount-badge_${type}`}>
        <div className="discount-badge__percent">
          <Trans
            id="plan.discount_percent_short"
            values={{ percent: discountPercent }}
          />
        </div>
        {type === 'three_months' && (
          <SVGInline svg={DiscountBackground} className="discount-badge__bg" />
        )}
      </div>
    )
  }
}
